import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { ElConfigProvider } from 'element-plus'
import { nextTick, ref, provide, onMounted } from 'vue'
import { useCommon } from '@/store/useCommon';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const storeCommon = useCommon()

const isShow = ref(true)
const PageReload = () => {
  isShow.value = false
  nextTick(() => {
    isShow.value = true
  })
}
provide('PageReload', PageReload)

onMounted(() => {
  storeCommon.resetIncludePage()
  storeCommon.clearAddType()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), null, {
    default: _withCtx(() => [
      (isShow.value)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})